import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent20 } from "./VipVipHistoryCRUD";
import { vipVipHistorySlice } from "./VipVipHistorySlice";

const { actions } = vipVipHistorySlice;

export const fetchVipVipHistory = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  dispatch(actions.vipVipHistoryFetched({ data: null }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipVipHistoryFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipVipHistory");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipVipHistoryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  dispatch(actions.vipVipHistoryDetailFetched({ data: null }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipVipHistoryDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipVipHistoryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
